import { sipPhoneStatuses } from '../../../components/SipPhoneProvider';
import { roundIconBgTypes } from './common';

const {
  SIP_STATUS_DISCONNECTED,
  SIP_STATUS_CONNECTING,
  SIP_STATUS_CONNECTED,
  SIP_STATUS_REGISTERED,
  SIP_STATUS_ERROR,
} = sipPhoneStatuses;

export const sipStatusState = {
  [SIP_STATUS_DISCONNECTED]: {
    tooltip: 'Не подключено',
    containerType: roundIconBgTypes.disconnected,
  },
  [SIP_STATUS_CONNECTING]: {
    tooltip: 'Подключаемся к серверу...',
    loading: true,
  },
  [SIP_STATUS_CONNECTED]: { tooltip: 'Подключено' },
  [SIP_STATUS_REGISTERED]: { tooltip: 'Зарегистрировано' },
  [SIP_STATUS_ERROR]: {
    tooltip: 'Не удалось подключиться к серверу',
    containerType: roundIconBgTypes.drop,
  },
};
